import { useState } from 'react';
import { Link } from 'react-router-dom';
import { eventPlatformApi } from '../../api/eventplatform';

export function ReplayManagerPage() {
  const [eventName, setEventName] = useState('');
  const [eventID, setEventID] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  async function handleReplay(e: React.FormEvent) {
    e.preventDefault();
    try {
      const r = await eventPlatformApi.replay({
        event_id: eventID || undefined,
        event_name: eventName || undefined,
        limit: 100,
      });
      setStatus(`Replayed ${r.replayed} event(s).`);
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div className="mx-auto max-w-2xl p-6">
      <Link to="/events" className="text-sm text-blue-600 hover:underline">← Event Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Replay Manager</h1>
      <form onSubmit={(e) => void handleReplay(e)} className="mt-6 space-y-4">
        <label className="block">
          <span className="text-sm">Event ID</span>
          <input value={eventID} onChange={(e) => setEventID(e.target.value)} className="mt-1 w-full rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        </label>
        <label className="block">
          <span className="text-sm">Event name</span>
          <input value={eventName} onChange={(e) => setEventName(e.target.value)} className="mt-1 w-full rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        </label>
        <button type="submit" className="rounded bg-blue-600 px-4 py-2 text-white">Replay</button>
      </form>
      {status && <p className="mt-4 text-sm text-green-600">{status}</p>}
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
    </div>
  );
}
